export const featuresObj = {
    "Vishing": false,
    "Smishing": false,
    "Phishing": false,
    "Ransomware": false,
    "Cyber Scam": false,
    "Removal Media": false,
    "WhatsApp": false,
    "Attachment": false,
    "QRcode": false,
    "fake-cc": false,
    "reply-tracking-over-phishing": false,
    "ai-template": false,
    "employee-vulnerability-score": false,
    "hack-record": false,
    "Telegram": false,
    "AI Vishing": false,
};
